import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CRYPTO_CURRENCIES_MAPPING } from 'utils/constants/account/crypto-currencies';
import { addQuery, saveCurrentLocation } from 'components/QueryRoute';
import { useGetCurrencyConfigs } from 'hooks/useGetCurrencyConfigs';
import { getIsLoggedIn, getUser } from 'store/selectors/user-data';

export const CurrencyRelatedLogic = () => {
  useGetCurrencyConfigs();
  const history = useHistory();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const user = useSelector(getUser);

  useEffect(() => {
    if (!user.pending) {
      const switchCurrency = (event: MessageEvent) => {
        if (
          event.data &&
          event.data.action === 'switchCurrency' &&
          event.data.currencyId === CRYPTO_CURRENCIES_MAPPING.FTNF.currency
        ) {
          if (isLoggedIn) {
            history.push(
              addQuery({
                selected_wallet: CRYPTO_CURRENCIES_MAPPING.FTNF.currency
              })
            );
          } else {
            history.push(
              addQuery({
                selected_wallet: CRYPTO_CURRENCIES_MAPPING.FTNF.currency
              })
            );
            saveCurrentLocation(
              'login',
              `${window.getPathname()}?selected_wallet=${
                CRYPTO_CURRENCIES_MAPPING.FTNF.currency
              }`
            );
            history.push(addQuery({ accounts: '*', login: '*' }));
          }
        }
      };

      window.addEventListener('message', switchCurrency, false);

      return () => {
        window.removeEventListener('message', switchCurrency);
      };
    }
  }, [user.pending, isLoggedIn]);

  return null;
};
